// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"a83b8d24","167":"37726067","213":"232f4693","238":"7077d31c","239":"0ee893f4","291":"69c4f4d9","557":"82f198a0","668":"3fba15d4","685":"2399723e","732":"fe2230c9","762":"652b2c04"}[chunkId] + ".chunk.js";
};